module.exports = __webpack_public_path__ + "img/borderwavesgreen.51b86e65.png";